export default __webpack_public_path__ + "images/master-card.png";